module.exports = "#define GLSLIFY 1\nvarying vec2 vUv;\n\nuniform float aspect;\n\nfloat when_fgt(float x, float y) {\n  return max(sign(x - y), 0.0);\n}\n\nvoid main() {\n\n  vUv = vec2(0.5)+(position.xy)*0.5;\n\n  gl_Position = vec4( position.xy, 0.0,  1.0 );\n\n}"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/Trail/modules/postprocessing/quad/blend/main.vert
// module id = tV3y
// module chunks = 1